export const getContentTitle = (titleKey) => {
  if (titleKey === "banners") return "Banner - ";
  if (titleKey === "aboutus") return "About Us - ";
  if (titleKey === "worksteps") return "Work Step - ";
  if (titleKey === "projects") return "Project - ";
  if (titleKey === "testimonials") return "Testimonial - ";
  if (titleKey === "awards") return "Awards - ";
  if (titleKey === "services") return "Services - ";
};
